import * as React from "react";
import { forwardRef } from "react";
const SvgMiniX = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 6, height: 6, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m5.131 4 1.635-1.634a.8.8 0 0 0-1.132-1.132L4 2.869 2.366 1.234a.8.8 0 1 0-1.132 1.132L2.869 4 1.234 5.634a.8.8 0 1 0 1.132 1.132L4 5.131l1.634 1.635a.8.8 0 1 0 1.132-1.132Z", style: {
  fill: "#009f87"
}, transform: "rotate(-90 3 4)" }));
const ForwardRef = forwardRef(SvgMiniX);
export { ForwardRef as ReactComponent };
